export default __webpack_public_path__ + "static/media/rated_star.fb1efe7e.svg";